import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { InfoService } from '../services/sections/info/info.service';
import { InfoPayload } from '../models/info/info-payload.model';

@Injectable({
	providedIn: 'root'
})
export class InfoResolver implements Resolve<Observable<InfoPayload>> {

	constructor(
		private router: Router,
		private infoService: InfoService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;
		GlobalSettingsService.navigationBarActions.clear();
		GlobalSettingsService.isJobCompletedStatusVisible = false;

		return this.infoService
			.getInfoDetails(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
